import React from "react";

/**
 * FormField - Reusable form field component with consistent styling
 *
 * @param {Object} props
 * @param {string} props.id - Input ID
 * @param {string} props.label - Field label
 * @param {string} props.type - Input type (text, email, etc.)
 * @param {string} props.value - Field value
 * @param {Function} props.onChange - Change handler
 * @param {string} props.placeholder - Placeholder text
 * @param {boolean} props.required - Whether field is required
 * @param {string} props.className - Additional class names
 * @param {React.ReactNode} props.children - Optional children to replace default input
 */
const FormField = ({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  required = false,
  className = "",
  children,
}) => {
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-300 mb-1"
      >
        {label} {required && <span className="text-red-400">*</span>}
      </label>

      {children || (
        <input
          type={type}
          id={id}
          value={value}
          onChange={onChange}
          className="w-full p-2 border border-[#2f3236] rounded focus:ring-[#4db1e0] focus:border-[#4db1e0] bg-[#262b30] text-gray-200"
          placeholder={placeholder}
          required={required}
        />
      )}
    </div>
  );
};

export default FormField;
